import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ErrorTemplateDesign from './ErrorTemplateDesign.jsx';
import RenderJsonSlideTemplate from './RenderJsonSlideTemplate.jsx';
import { getFontFormatFromName } from '../CustomFontsUpload/CustomFontsUtils.js';

/**
 * 
 * render the template design based on the JSON data recevied from Image generator, 
 * will only be used by the backend to generate the images 
 */
const defaultTemplate=[
      {
        "isPageSelected": false,
        "PageTitle": "Page",
        "PageHeight": 1080,
        "PageWidth": 1920,
        "PageMinimumHeight": 500,
        "PageWidthInInches": 16,
        "PageHeightInInches": 9,
        "PageBorder": "solid",
        "PageBorderColor": "#25a1ce",
        "PageBorderWidth": 15,
        "PageBackgroundColor": "#2f456b",
        "PageBackgroundImage": "https://d2r7gzhdm0chmg.cloudfront.net/slideapp/pre-made-templates/Outting/Outting.png?Expires=1760011883&Key-Pair-Id=K1SXWTGKOAMF4R&Signature=WkE2BPkCmxS9HihSk3PNle~p5XxAbQITpJCDvdIW4MHsNWVXrDgeRYuqscQeYCv4Lc4iYlfM--2ev-RgALp38DCGtoBbpeH0PnL229LIVHHk7kb2subBK0-kF5nRsvmNyzk9FCCSk1cZmAIZk4hxpO0cBFLEqoRPdRzNwBNx~gf9Z4yvOs0l7K3nKwwt4kktfxuiRzaOM5GkSGVkktbXGbdl4yB3ixyom8Y8aOX55hzYtqPDcB4ZlRVpr8Bg1Ji7zd3GY6CJWrY2G8mscJp48gvd7od5P6fps~zey1e4PA5x2GYoO~R1wWwFz62Yw8OF~r2pcuVV4zCVTe7Ii9EHJQ__",
        "PageBackgroundImageRepeatStatus": false,
        "IsPageBorderIsImage": false,
        "PageBorderImage": null,
        "PageBorderImageName": null,
        "PageBackgroundImageName": "Outting.png",
        "PageOpacity": 1,
        "Elements": [
          {
            "ElementType": "Heading",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "Today",
            "Styles": [
              {
                "ElementWidth": 796,
                "ElementHeight": 131,
                "ElementTop": 143.27536088832915,
                "ElementLeft": 274.6956483592158,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 30,
                "ElementMinWidth": 100,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#2f456b",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 0,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 1,
                "ElementFontFamily": "PT Serif",
                "ElementFontSize": 80,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 700,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#ffffff",
                "ElementTextAlignment": "center"
              }
            ]
          },
          {
            "ElementType": "Paragraph",
            "isElementSelected": true,
            "IsElementLocked": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "TUESDAY AT 12 PM \nMEET IN THE FRONT \nLOBBY",
            "Styles": [
              {
                "ElementWidth": 903,
                "ElementHeight": 450,
                "ElementTop": 363.98550528687394,
                "ElementLeft": 358.5507246078789,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 30,
                "ElementMinWidth": 100,
                "ElementBorderPatteren": "solid",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 0,
                "ElementBackgroundColor": "#2f456b",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 0,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 0.8,
                "ElementFontFamily": "PT Serif",
                "ElementFontSize": 80,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 200,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#ffffff",
                "ElementTextAlignment": "center"
              }
            ]
          },
          {
            "ElementType": "Heading",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "Header",
            "Styles": [
              {
                "ElementWidth": 500,
                "ElementHeight": 100,
                "ElementTop": -0.43125152587890625,
                "ElementLeft": -0.7999886775362319,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 30,
                "ElementMinWidth": 100,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#ffffff",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 0,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 0,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 30,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 700,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "center"
              }
            ]
          },
          {
            "ElementType": "Text",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "<p>text <span style=\"color: #1c80a5\">text</span></p>",
            "Styles": [
              {
                "ElementWidth": 500,
                "ElementHeight": 200,
                "ElementTop": -0.43125152587890625,
                "ElementLeft": 1419.2000113224638,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 30,
                "ElementMinWidth": 100,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#F1C40F",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 0,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 0.8,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 24,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 200,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "justify"
              }
            ]
          },
          {
            "ElementType": "RTE",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "<p>test text</p>",
            "Styles": [
              {
                "ElementWidth": 400,
                "ElementHeight": 400,
                "ElementTop": 217.7275319859603,
                "ElementLeft": 1514.9797044836964,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 200,
                "ElementMinWidth": 300,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#F1C40F",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBorderRadius": 0,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 0.8,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 24,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 400,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "left"
              }
            ]
          },
          {
            "ElementType": "Date",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "Wednesday, October 8, 2025",
            "Styles": [
              {
                "ElementWidth": 432,
                "ElementHeight": 141,
                "ElementTop": 80.45216966711935,
                "ElementLeft": 21.64637115036234,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 30,
                "ElementMinWidth": 100,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#ffffff",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 0,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 0,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 30,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 700,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "left"
              }
            ]
          },
          {
            "ElementType": "Image",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "",
            "Styles": [
              {
                "ElementWidth": 400,
                "ElementHeight": 225,
                "ElementTop": 236.27825662364114,
                "ElementLeft": 14.226081295289848,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 5,
                "ElementMinWidth": 5,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#FFFFFF",
                "ElementBackgroundImage": "https://d2r7gzhdm0chmg.cloudfront.net/slideapp/bg-nd-border-images/yoga.jpg?Expires=1760011883&Key-Pair-Id=K1SXWTGKOAMF4R&Signature=XlvoEU-R2di2WkwWzvE4u0V4YGFLIFg~PlffvssfNxes04rfO0CCcqevSd9kqMu168xUdR-0N5bP9cBhzbNkyoDZxxAt7QR1ksscmsHTWTLAKDDl~xYU4SKKS6RzFcpWTvsDpisIvXXxW04JVRay~Y72ZoJCixdpPAsE5vsgz~1He~dxBafxdEeKVBO8SMbV~3R81AEsw52iaB7aWgZAAEu9begBXX5F1yAHoiAlKKj0h-2FJZ-lWJdrEyKhNxdaUwsJT2CrmHmRMlufUKLJZMuNP13YJSsI-g2IEd2s8u9dwTu4jBQ~8lGQ0JtnPy7IPvRURdch2gbNSqvp6GPNUg__",
                "ElementBorderImage": null,
                "ElementBorderRadius": 0,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderImageName": "",
                "ElementBackgroundImageName": "yoga",
                "ElementOpacity": 1,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 15,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 400,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "left",
                "ImageAspect": 1.7777777777777777
              }
            ]
          },
          {
            "ElementType": "Video",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "https://www.youtube.com/watch?v=tiaFVm698Sc",
            "Styles": [
              {
                "ElementWidth": 640,
                "ElementHeight": 360,
                "ElementTop": 722.3072421308868,
                "ElementLeft": 1.055083786232359,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 30,
                "ElementMinWidth": 100,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#F3F4F6",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 0,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 1,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 24,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 200,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "justify"
              }
            ]
          },
          {
            "ElementType": "Bullets",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "",
            "Styles": [
              {
                "ElementWidth": 50,
                "ElementHeight": 50,
                "ElementTop": 720.4521696671196,
                "ElementLeft": 887.9652117300725,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 5,
                "ElementMinWidth": 5,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#000000",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 100,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 1,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 24,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 200,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "justify"
              }
            ]
          },
          {
            "ElementType": "Line",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "",
            "Styles": [
              {
                "ElementWidth": 500,
                "ElementHeight": 5,
                "ElementTop": 835.4666624207428,
                "ElementLeft": 1273.8202841938394,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 5,
                "ElementMinWidth": 5,
                "ElementBorderPatteren": "solid",
                "ElementBorderColor": "#ffffff",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#000000",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBorderRadius": 0,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderImageName": "",
                "ElementBackgroundImageName": "",
                "ElementOpacity": 1,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 15,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 400,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#000000",
                "ElementTextAlignment": "left"
              }
            ]
          },
          {
            "ElementType": "Icon",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "",
            "Styles": [
              {
                "ElementIcon": "<?xml version=\"1.0\" encoding=\"utf-8\"?>\r\n<!-- Generator: Adobe Illustrator 17.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\r\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t width=\"56.693px\" height=\"56.693px\" viewBox=\"0 0 56.693 56.693\" enable-background=\"new 0 0 56.693 56.693\" xml:space=\"preserve\">\r\n<path fill=\"#474A56\" d=\"M28.343,4.493C14.615,4.493,3.49,15.616,3.49,29.343c0,13.731,11.125,24.858,24.853,24.858\r\n\tc13.729,0,24.861-11.127,24.861-24.858C53.203,15.616,42.071,4.493,28.343,4.493z M39.491,32.258h-8.243v8.223\r\n\tc0,1.611-1.293,2.913-2.906,2.913c-1.605,0-2.906-1.302-2.906-2.913v-8.223H17.21c-1.611,0-2.905-1.306-2.905-2.909\r\n\tc0-1.611,1.294-2.907,2.905-2.907h8.227v-8.236c0-1.607,1.301-2.905,2.906-2.905c1.613,0,2.906,1.298,2.906,2.905v8.236h8.243\r\n\tc1.603,0,2.905,1.296,2.905,2.907C42.396,30.952,41.094,32.258,39.491,32.258z\"/>\r\n</svg>\r\n",
                "ElementWidth": 196,
                "ElementHeight": 215,
                "ElementTop": 170.84058030769916,
                "ElementLeft": 1030.492751232971,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 50,
                "ElementMinWidth": 50,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#F1C40F",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 1,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 0.8,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 24,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 300,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#3498DB",
                "ElementTextAlignment": "center"
              }
            ]
          },
          {
            "ElementType": "Table",
            "isElementSelected": false,
            "IsElementLocked": false,
            "IsElementPrivate": false,
            "IsElementDragable": false,
            "isElementResizeAble": false,
            "ElementData": "Table Element",
            "IsWholeTableSelected": false,
            "SelectedColumn": {
              "Column": null,
              "IsSelected": false
            },
            "TableDetails": [
              {
                "RowHeight": 50,
                "IsSelectedRow": false,
                "RowCells": [
                  {
                    "CellData": "22",
                    "IsCellActive": false,
                    "CellStyles": {
                      "CellWidth": 200,
                      "CellZIndex": 10,
                      "CellMinHeight": 30,
                      "CellMinWidth": 100,
                      "CellBorderPatteren": "solid",
                      "CellBorderColor": "#000000",
                      "CellBorderWidth": 1,
                      "CellBackgroundColor": "#3498DB",
                      "CellBackgroundImage": null,
                      "CellBorderImage": null,
                      "CellBackgroundImageRepeatStatus": false,
                      "CellBorderIsImage": false,
                      "CellBorderRadius": 0,
                      "CellBorderImageName": null,
                      "CellBackgroundImageName": null,
                      "CellOpacity": 0.8,
                      "CellFontFamily": "Lato",
                      "CellFontSize": 15,
                      "CellFontStyle": "Normal",
                      "CellFontWeight": 700,
                      "CellLetterSpacing": 1,
                      "CellLineHeight": 1.5,
                      "CellTextColor": "#F1C40F",
                      "CellTextAlignment": "center",
                      "CellTextDecoration": ""
                    }
                  },
                  {
                    "CellData": "12",
                    "IsCellActive": false,
                    "CellStyles": {
                      "CellWidth": 200,
                      "CellZIndex": 10,
                      "CellMinHeight": 30,
                      "CellMinWidth": 100,
                      "CellBorderPatteren": "solid",
                      "CellBorderColor": "#000000",
                      "CellBorderWidth": 1,
                      "CellBackgroundColor": "#3498DB",
                      "CellBackgroundImage": null,
                      "CellBorderImage": null,
                      "CellBackgroundImageRepeatStatus": false,
                      "CellBorderIsImage": false,
                      "CellBorderRadius": 0,
                      "CellBorderImageName": null,
                      "CellBackgroundImageName": null,
                      "CellOpacity": 0.8,
                      "CellFontFamily": "Lato",
                      "CellFontSize": 15,
                      "CellFontStyle": "Normal",
                      "CellFontWeight": 700,
                      "CellLetterSpacing": 1,
                      "CellLineHeight": 1.5,
                      "CellTextColor": "#F1C40F",
                      "CellTextAlignment": "center",
                      "CellTextDecoration": ""
                    }
                  }
                ]
              },
              {
                "RowHeight": 50,
                "IsSelectedRow": false,
                "RowCells": [
                  {
                    "CellData": "112",
                    "IsCellActive": false,
                    "CellStyles": {
                      "CellWidth": 200,
                      "CellZIndex": 10,
                      "CellMinHeight": 30,
                      "CellMinWidth": 100,
                      "CellBorderPatteren": "solid",
                      "CellBorderColor": "#000000",
                      "CellBorderWidth": 1,
                      "CellBackgroundColor": "#3498DB",
                      "CellBackgroundImage": null,
                      "CellBorderImage": null,
                      "CellBackgroundImageRepeatStatus": false,
                      "CellBorderIsImage": false,
                      "CellBorderRadius": 0,
                      "CellBorderImageName": null,
                      "CellBackgroundImageName": null,
                      "CellOpacity": 0.8,
                      "CellFontFamily": "Lato",
                      "CellFontSize": 15,
                      "CellFontStyle": "Normal",
                      "CellFontWeight": 700,
                      "CellLetterSpacing": 1,
                      "CellLineHeight": 1.5,
                      "CellTextColor": "#F1C40F",
                      "CellTextAlignment": "center",
                      "CellTextDecoration": ""
                    }
                  },
                  {
                    "CellData": "112",
                    "IsCellActive": false,
                    "CellStyles": {
                      "CellWidth": 200,
                      "CellZIndex": 10,
                      "CellMinHeight": 30,
                      "CellMinWidth": 100,
                      "CellBorderPatteren": "solid",
                      "CellBorderColor": "#000000",
                      "CellBorderWidth": 1,
                      "CellBackgroundColor": "#3498DB",
                      "CellBackgroundImage": null,
                      "CellBorderImage": null,
                      "CellBackgroundImageRepeatStatus": false,
                      "CellBorderIsImage": false,
                      "CellBorderRadius": 0,
                      "CellBorderImageName": null,
                      "CellBackgroundImageName": null,
                      "CellOpacity": 0.8,
                      "CellFontFamily": "Lato",
                      "CellFontSize": 15,
                      "CellFontStyle": "Normal",
                      "CellFontWeight": 700,
                      "CellLetterSpacing": 1,
                      "CellLineHeight": 1.5,
                      "CellTextColor": "#F1C40F",
                      "CellTextAlignment": "center",
                      "CellTextDecoration": ""
                    }
                  }
                ]
              }
            ],
            "Styles": [
              {
                "ElementWidth": 400,
                "ElementHeight": 106,
                "ElementTop": 846.872459522192,
                "ElementLeft": 1278.008689990942,
                "ElementZIndex": 10,
                "ElementRotation": 0,
                "ElementMinHeight": 30,
                "ElementMinWidth": 100,
                "ElementBorderPatteren": "none",
                "ElementBorderColor": "#000000",
                "ElementBorderWidth": 1,
                "ElementBackgroundColor": "#ffffff",
                "ElementBackgroundImage": null,
                "ElementBorderImage": null,
                "ElementBackgroundImageRepeatStatus": false,
                "ElementBorderIsImage": false,
                "ElementBorderRadius": 0,
                "ElementBorderImageName": null,
                "ElementBackgroundImageName": null,
                "ElementOpacity": 0,
                "ElementFontFamily": "Lato",
                "ElementFontSize": 30,
                "ElementFontStyle": "Normal",
                "ElementFontWeight": 700,
                "ElementLetterSpacing": 1,
                "ElementLineHeight": 1.5,
                "ElementTextColor": "#F1C40F",
                "ElementTextAlignment": "center"
              }
            ]
          }
        ]
      }
    ];
const RenderTemplateDesign = () => {
  const location=useLocation();
  const [IsVerified,setIsVerified]=useState(false);
  const [TemplateDesign,setTemplateDesign]=useState([]);
  useEffect(()=>{
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    let templateUrl = queryParams.get("templateUrl");
     templateUrl = decodeURIComponent(templateUrl);

    console.log("template url ",templateUrl);
     if (!token || !templateUrl) {
      console.warn("Missing required query params!");
      setIsVerified(false);
      return;
    }else{
      setIsVerified(true);
      handleGetTemplateDeisgnData(templateUrl);
    }
  },[]);

  // handle get the tempalte design data
  const handleGetTemplateDeisgnData=async(templtedesingurl)=>{
    /**
     * 1. fetch the JSON file, and get its contents. 
     * 2. seprate the customFonts and templateDesign
     * 3. add the fonts 
     * 5. render the design 
     * 6. devise a mechanasim to let puppeteer know that everything is ready. 
     */
        let designJSON=await fetchTheTemplateJson(templtedesingurl);
        if(designJSON===null)
        {
          setIsVerified(false);
          return;
        }
        let {templateDesign,customFonts}=designJSON;
        console.log("template design is ",templateDesign);
        console.log("custom fonts are",customFonts);
        setTemplateDesign(templateDesign);
        await addCustomFonts(customFonts);
  };
  
  /**
   * 
   * fetch the template JSON 
   */
  const fetchTheTemplateJson=async(templatedesignurl)=>{
    try{
      const res = await fetch(templatedesignurl, { credentials: "omit", cache: "no-store" });
      if (!res.ok) return null;
      const data = await res.json();
      console.log("Template JSON is",JSON.stringify(data));
      return data;
    }catch(error){
      console.log("error fetchign the data");
      return null;
    }
    
  };

  /**
   * add the custom fonts 
   */
  const addCustomFonts = async (customFonts = []) => {
  if (!Array.isArray(customFonts) || customFonts.length === 0) {
    console.warn("No custom fonts to load");
    document.fontsReady = true; // mark as ready (no fonts)
    return;
  }

  // Create or clear a document-level list
  document.loadedFonts = [];
  document.fontsReady = false; // start as not ready

  for (let { fontName, fontsignedUrl } of customFonts) {
    const family = fontName.replace(/\.[^/.]+$/, "");
    const format = getFontFormatFromName(fontName);

    try {
      const face = new FontFace(
        family,
        `url(${fontsignedUrl}) format('${format}')`
      );
      await face.load();
      document.fonts.add(face);

      
      

      // Record in global document state
      document.loadedFonts.push(family);
      console.log(`✅ Loaded font: ${family}`);

      // Inject @font-face CSS (optional redundancy)
      const css = `
        @font-face {
          font-family: '${family}';
          src: url('${fontsignedUrl}') format('${format}');
          font-weight: normal;
          font-style: normal;
        }
      `;
      const styleTag = document.createElement("style");
      styleTag.textContent = css;
      document.head.appendChild(styleTag);
    } catch (err) {
      console.error(`❌ Failed to load ${family}`, err);
    }
  }

  // Once all fonts attempted:
  document.fontsReady = true;
  console.log("🎯 All fonts processed and document.fontsReady = true");
};

  
  return (
    
      IsVerified===true?(
        <div><RenderJsonSlideTemplate TemplateDesign={TemplateDesign} /></div>
      ):(

      <ErrorTemplateDesign/>
    )
    
    
  )
}

export default RenderTemplateDesign